import React from 'react';
import { useTranslation } from 'react-i18next';
import { MyOrders } from '@components/templates/myAccount';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';

export function MyOrdersPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('my-orders-component.metatags.title'),
        description: t('my-orders-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myOrders,
        index: false,
    });

    return (
        <FiltersProvider>
            <MyOrders />
        </FiltersProvider>
    );
}
